import { DepartmentsEntity } from './../../hooks/useFulfillDepartments';
import { ISingleFlag } from './../../constans/flags';
import { IParticipantsItem } from './../../services/surveys';
import { object, string } from 'yup';
import * as Yup from 'yup';
import i18n from '../../i18n';

const participantSchemaBuilder = (
  isEffectSurvey: boolean,
  editData: IParticipantsItem | undefined,
  getLangObjectShort: (key: string) => ISingleFlag,
  userLang: string,
  departments: DepartmentsEntity[]
) => {
  const baseParticipantSchema = object({
    name: string().required(i18n.t('viewSurvey.participants.modals.validations.nameIsRequired')),
    emailAddress: string()
      .email('Incorrect email format')
      .required(i18n.t('viewSurvey.participants.modals.validations.emailIsRequired')),
    phoneNo: string().test((value, { createError, path }) => {
      const regex = /^(([(][+]?[0-9]{1,4}[)])|[+]?[0-9]{1,4})[-\s.0-9]{2,}$/;
      if (value) {
        const matchVal = !!value?.match(regex);
        if (!matchVal) {
          return createError({
            path,
            message: i18n.t('viewSurvey.participants.modals.validations.invalidPhoneNumber'),
          });
        }
        return matchVal;
      }
      return true;
    }),
    preferredLanguage: object().nullable(),
  });

  const effectSurveySchema = baseParticipantSchema.shape({
    role: string()
      .required(i18n.t('viewSurvey.participants.modals.validations.respondents'))
      .test(
        'unique-director',
        i18n.t('viewSurvey.participants.modals.validations.directorError'),
        (value, { parent }) => {
          if (value === 'director') {
            const departmentId = parent.department?.id;
            if (departmentId) {
              const department = departments.find(dept => dept.id === departmentId);
              const directorCount = Number(department?.memberCount?.director);
              return directorCount < 1;
            }
            return true;
          }
          return true;
        }
      ),
    department: Yup.object()
      .shape({
        id: Yup.string().required(i18n.t('viewSurvey.participants.modals.validations.departments')),
        name: Yup.string().required(
          i18n.t('viewSurvey.participants.modals.validations.departments')
        ),
      })
      .required(i18n.t('viewSurvey.participants.modals.validations.departments')),
  });

  const nonEffectSurveySchema = baseParticipantSchema.shape({
    team: string().required(i18n.t('viewSurvey.participants.modals.validations.teamIsRequired')),
    leader: string().required(
      i18n.t('viewSurvey.participants.modals.validations.leaderIsRequired')
    ),
  });

  const commonFields = {
    name: editData?.name || '',
    emailAddress: editData?.emailAddress || '',
    phoneNo: editData?.phoneNo || '',
    preferredLanguage: editData?.preferredLanguage
      ? getLangObjectShort(editData?.preferredLanguage)
      : getLangObjectShort(userLang),
  };

  const effectFields = {
    role: editData?.role || '',
    department: editData ? departments.find(dept => dept.id === String(editData.department)) : {},
  };

  const nonEffectFields = {
    team: editData?.team || '',
    leader: editData?.leader || '',
  };

  return {
    defaultValues: { ...commonFields, ...(isEffectSurvey ? effectFields : nonEffectFields) },
    defaultSchema: isEffectSurvey ? effectSurveySchema : nonEffectSurveySchema,
  };
};

export default participantSchemaBuilder;
